// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"888":"2265dbb9126a90627be2","908":"72a5f87f153f067f70a0"}[chunkId] + ".css";
};